<style>
.week_table td{border: 1px solid #f0f0f0; font-size: 12px!important;}
.week_table th{border: 1px solid #f0f0f0;font-size: 11px!important;}
.week_total td{background-color: #f8f8f8;}
.new{background:#0d35cf; color:#fff; padding:1px 4px; border-radius:6px; font-size:9px;margin-right:2px;}
.fr td{ height: 30px!important; border:1px solid #ccc;}
</style>
<template>
  <div class="row" style="padding: 20px">
    <div class="col-lg-12" style="margin-left: 10px">
      <div class="main-card mb-12 card">
        <div style="margin: 0px 20px 20px 20px">
          <ul style="color: #000">
            <li
              v-for="(includes, board) in boards"
              :class="{ active: selBoard === board }"
              v-on:click="
                selBoard = board;
                loadBoard();
              "
              v-bind:key="board"
              style="font-size:20px;important;font-weight:bold;"
            >
              <a href="#" data-toggle="tab">{{ board }}</a>
            </li>
          </ul>
          <div class="tab-content">
            <div id="home">
              <h5 class="card-title">
                아이디 사용현황
                <div
                  class="sub_title"
                  style="
                    margin-bottom: 20px;
                    color: #333;
                    font-size: 13px;
                    border: 1px solid #ccc;
                    background: #f8f8f8;
                    height: 30px;
                    text-align: right;
                    position: absolute;
                    right: 20px;
                    top: 10px;
                    padding: 2px 10px;
                  "
                >
                  통계관리 → 아이디 사용현황
                </div>
              </h5>

<div style="width:100%; overflow:auto;">


  <table class="fr" style="width:4000px; font-size:12px; ">

    <tr>
    <th>번호</th>
    <th>캠퍼스명</th>
    <th>01월 26일</th>
    <th>02월 02일</th>
    <th>02월 09일</th>
    <th>02월 16일</th>
    <th>02월 23일</th>
    <th>03월 06일</th>
    <th>03월 11일</th>
    <th>03월 18일</th>
    <th>03월 22일</th>
    <th>03월 29일</th>
    <th>04월 05일</th>
    <th>04월 12일</th>
    <th>04월 19일</th>
    <th>04월 26일</th>
    <th>05월 03일</th>
    <th>05월 10일</th>
    <th>05월 17일</th>
    <th>05월 24일</th>
    <th>05월 31일</th>
    <th>06월 07일</th>
    <th>06월 14일</th>
    <th>06월 21일</th>
    <th>06월 28일</th>
    <th>07월 05일</th>
    <th>07월 12일</th>
    <th>07월 19일</th>
    <th>07월 26일</th>
    <th>08월 02일</th>
    <th>08월 09일</th>
    <th>08월 16일</th>
    <th>08월 23일</th>
    <th>08월 30일</th>
    <th>09월 06일</th>
    <th>09월 13일</th>
    <th>09월 20일</th>
    <th>09월 27일</th>
    <th>10월 04일</th>
    <th>10월 11일</th>
    <th>10월 18일</th>
    <th>10월 25일</th>
    <th>11월 01일</th>
    <th>11월 08일</th>
    <th>11월 15일</th>
    <th>11월 22일</th>
    <th>11월 29일</th>
    <th>12월 06일</th>
    <th>12월 13일</th>
    <th>12월 20일</th>
    <th>12월 27일</th>
  </tr>
  <tr>
    <td>1</td>
    <td>★유베스타 캠퍼스</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>0</td>
    <td>0</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>2</td>
    <td>SnT신창 캠퍼스</td>
    <td>15</td>
    <td>16</td>
    <td>16</td>
    <td>12</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>13</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>3</td>
    <td>가재울 CL어학원</td>
    <td>114</td>
    <td>114</td>
    <td>114</td>
    <td>93</td>
    <td>92</td>
    <td>86</td>
    <td>20</td>
    <td>7</td>
    <td>3</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>4</td>
    <td>강동(하버드브레인)</td>
    <td>28</td>
    <td>29</td>
    <td>30</td>
    <td>29</td>
    <td>31</td>
    <td>37</td>
    <td>37</td>
    <td>38</td>
    <td>36</td>
    <td>35</td>
    <td>38</td>
    <td>38</td>
    <td>37</td>
    <td>37</td>
    <td>37</td>
    <td>39</td>
    <td>38</td>
    <td>37</td>
    <td>37</td>
    <td>38</td>
    <td>35</td>
    <td>34</td>
    <td>34</td>
    <td>35</td>
    <td>35</td>
    <td>33</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>5</td>
    <td>강동고덕 캠퍼스</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>6</td>
    <td>강릉교동 캠퍼스</td>
    <td>17</td>
    <td>17</td>
    <td>27</td>
    <td>27</td>
    <td>27</td>
    <td>48</td>
    <td>48</td>
    <td>46</td>
    <td>45</td>
    <td>45</td>
    <td>47</td>
    <td>47</td>
    <td>47</td>
    <td>47</td>
    <td>48</td>
    <td>47</td>
    <td>46</td>
    <td>46</td>
    <td>46</td>
    <td>46</td>
    <td>46</td>
    <td>46</td>
    <td>46</td>
    <td>46</td>
    <td>45</td>
    <td>45</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>7</td>
    <td>강릉노암 캠퍼스</td>
    <td>38</td>
    <td>38</td>
    <td>38</td>
    <td>38</td>
    <td>38</td>
    <td>47</td>
    <td>47</td>
    <td>48</td>
    <td>49</td>
    <td>50</td>
    <td>50</td>
    <td>50</td>
    <td>52</td>
    <td>51</td>
    <td>51</td>
    <td>51</td>
    <td>51</td>
    <td>48</td>
    <td>46</td>
    <td>46</td>
    <td>47</td>
    <td>43</td>
    <td>43</td>
    <td>43</td>
    <td>43</td>
    <td>43</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>8</td>
    <td>강릉중앙 캠퍼스</td>
    <td>29</td>
    <td>27</td>
    <td>27</td>
    <td>26</td>
    <td>24</td>
    <td>24</td>
    <td>24</td>
    <td>24</td>
    <td>21</td>
    <td>21</td>
    <td>21</td>
    <td>23</td>
    <td>23</td>
    <td>22</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>9</td>
    <td>강릉초당 캠퍼스</td>
    <td>17</td>
    <td>18</td>
    <td>19</td>
    <td>21</td>
    <td>21</td>
    <td>22</td>
    <td>24</td>
    <td>25</td>
    <td>26</td>
    <td>26</td>
    <td>26</td>
    <td>25</td>
    <td>21</td>
    <td>21</td>
    <td>21</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>22</td>
    <td>22</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>22</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>10</td>
    <td>개발팀</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>11</td>
    <td><span class="new">NEW</span>고척 캠퍼스</td>
    <td>65</td>
    <td>64</td>
    <td>64</td>
    <td>64</td>
    <td>62</td>
    <td>63</td>
    <td>63</td>
    <td>63</td>
    <td>63</td>
    <td>63</td>
    <td>64</td>
    <td>68</td>
    <td>70</td>
    <td>71</td>
    <td>71</td>
    <td>71</td>
    <td>70</td>
    <td>69</td>
    <td>69</td>
    <td>69</td>
    <td>68</td>
    <td>68</td>
    <td>68</td>
    <td>68</td>
    <td>68</td>
    <td>70</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>12</td>
    <td>관악신림 캠퍼스</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>13</td>
    <td><span class="new">NEW</span>광명(리딩브레인)</td>
    <td>14</td>
    <td>14</td>
    <td>13</td>
    <td>12</td>
    <td>12</td>
    <td>10</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>13</td>
    <td>12</td>
    <td>12</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>11</td>
    <td>10</td>
    <td>10</td>
    <td>11</td>
    <td>10</td>
    <td>11</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>14</td>
    <td>광명철산 캠퍼스</td>
    <td>52</td>
    <td>54</td>
    <td>54</td>
    <td>54</td>
    <td>56</td>
    <td>55</td>
    <td>55</td>
    <td>55</td>
    <td>55</td>
    <td>56</td>
    <td>56</td>
    <td>56</td>
    <td>56</td>
    <td>55</td>
    <td>56</td>
    <td>56</td>
    <td>56</td>
    <td>56</td>
    <td>55</td>
    <td>55</td>
    <td>53</td>
    <td>53</td>
    <td>53</td>
    <td>54</td>
    <td>53</td>
    <td>53</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>15</td>
    <td>광주(반세어학원)</td>
    <td>27</td>
    <td>28</td>
    <td>28</td>
    <td>27</td>
    <td>26</td>
    <td>26</td>
    <td>26</td>
    <td>24</td>
    <td>22</td>
    <td>22</td>
    <td>23</td>
    <td>23</td>
    <td>24</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>23</td>
    <td>24</td>
    <td>24</td>
    <td>24</td>
    <td>24</td>
    <td>24</td>
    <td>23</td>
    <td>23</td>
    <td>24</td>
    <td>25</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>16</td>
    <td>광주선운 캠퍼스</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>2</td>
    <td>2</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>17</td>
    <td>광주효천 캠퍼스</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>12</td>
    <td>12</td>
    <td>20</td>
    <td>20</td>
    <td>19</td>
    <td>19</td>
    <td>19</td>
    <td>19</td>
    <td>19</td>
    <td>19</td>
    <td>19</td>
    <td>19</td>
    <td>19</td>
    <td>19</td>
    <td>19</td>
    <td>19</td>
    <td>20</td>
    <td>20</td>
    <td>20</td>
    <td>20</td>
    <td>21</td>
    <td>20</td>
    <td>20</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>18</td>
    <td>구리제1 캠퍼스</td>
    <td>50</td>
    <td>51</td>
    <td>50</td>
    <td>47</td>
    <td>46</td>
    <td>43</td>
    <td>43</td>
    <td>40</td>
    <td>37</td>
    <td>37</td>
    <td>38</td>
    <td>35</td>
    <td>34</td>
    <td>34</td>
    <td>34</td>
    <td>35</td>
    <td>37</td>
    <td>37</td>
    <td>37</td>
    <td>40</td>
    <td>41</td>
    <td>41</td>
    <td>41</td>
    <td>41</td>
    <td>39</td>
    <td>37</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>19</td>
    <td>구미상모 캠퍼스</td>
    <td>57</td>
    <td>60</td>
    <td>59</td>
    <td>60</td>
    <td>60</td>
    <td>63</td>
    <td>61</td>
    <td>57</td>
    <td>55</td>
    <td>59</td>
    <td>60</td>
    <td>58</td>
    <td>57</td>
    <td>57</td>
    <td>57</td>
    <td>57</td>
    <td>57</td>
    <td>56</td>
    <td>57</td>
    <td>57</td>
    <td>56</td>
    <td>57</td>
    <td>56</td>
    <td>59</td>
    <td>56</td>
    <td>56</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>20</td>
    <td>금천 캠퍼스</td>
    <td>26</td>
    <td>26</td>
    <td>27</td>
    <td>26</td>
    <td>25</td>
    <td>25</td>
    <td>31</td>
    <td>32</td>
    <td>34</td>
    <td>34</td>
    <td>36</td>
    <td>36</td>
    <td>34</td>
    <td>35</td>
    <td>35</td>
    <td>35</td>
    <td>35</td>
    <td>35</td>
    <td>35</td>
    <td>35</td>
    <td>36</td>
    <td>36</td>
    <td>36</td>
    <td>40</td>
    <td>39</td>
    <td>38</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>21</td>
    <td>김천 캠퍼스</td>
    <td>12</td>
    <td>13</td>
    <td>14</td>
    <td>12</td>
    <td>11</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>22</td>
    <td><span class="new">NEW</span>김포한강 CL어학원</td>
    <td>33</td>
    <td>33</td>
    <td>33</td>
    <td>33</td>
    <td>34</td>
    <td>35</td>
    <td>36</td>
    <td>38</td>
    <td>35</td>
    <td>35</td>
    <td>34</td>
    <td>33</td>
    <td>33</td>
    <td>33</td>
    <td>33</td>
    <td>34</td>
    <td>35</td>
    <td>36</td>
    <td>36</td>
    <td>36</td>
    <td>36</td>
    <td>36</td>
    <td>35</td>
    <td>35</td>
    <td>35</td>
    <td>38</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>23</td>
    <td>남천캠퍼스</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>29</td>
    <td>29</td>
    <td>29</td>
    <td>29</td>
    <td>29</td>
    <td>29</td>
    <td>22</td>
    <td>22</td>
    <td>24</td>
    <td>24</td>
    <td>24</td>
    <td>22</td>
    <td>24</td>
    <td>24</td>
    <td>25</td>
    <td>22</td>
    <td>22</td>
    <td>22</td>
    <td>20</td>
    <td>18</td>
    <td>16</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>24</td>
    <td>대구죽곡 캠퍼스</td>
    <td>111</td>
    <td>111</td>
    <td>113</td>
    <td>113</td>
    <td>116</td>
    <td>118</td>
    <td>118</td>
    <td>119</td>
    <td>121</td>
    <td>120</td>
    <td>120</td>
    <td>120</td>
    <td>120</td>
    <td>120</td>
    <td>121</td>
    <td>121</td>
    <td>121</td>
    <td>121</td>
    <td>121</td>
    <td>121</td>
    <td>121</td>
    <td>115</td>
    <td>106</td>
    <td>107</td>
    <td>108</td>
    <td>108</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>25</td>
    <td>대전 가오 캠퍼스</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>26</td>
    <td>더라임영어학원</td>
    <td>5</td>
    <td>6</td>
    <td>7</td>
    <td>7</td>
    <td>9</td>
    <td>10</td>
    <td>10</td>
    <td>17</td>
    <td>22</td>
    <td>24</td>
    <td>24</td>
    <td>24</td>
    <td>23</td>
    <td>22</td>
    <td>21</td>
    <td>21</td>
    <td>19</td>
    <td>17</td>
    <td>9</td>
    <td>9</td>
    <td>6</td>
    <td>5</td>
    <td>5</td>
    <td>4</td>
    <td>4</td>
    <td>3</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>27</td>
    <td>도담 캠퍼스</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>28</td>
    <td>동해제2 캠퍼스</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>15</td>
    <td>14</td>
    <td>14</td>
    <td>15</td>
    <td>15</td>
    <td>15</td>
    <td>15</td>
    <td>16</td>
    <td>0</td>
    <td>0</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>29</td>
    <td>동해제일 캠퍼스</td>
    <td>47</td>
    <td>45</td>
    <td>46</td>
    <td>46</td>
    <td>45</td>
    <td>50</td>
    <td>50</td>
    <td>48</td>
    <td>44</td>
    <td>42</td>
    <td>44</td>
    <td>43</td>
    <td>42</td>
    <td>42</td>
    <td>42</td>
    <td>42</td>
    <td>41</td>
    <td>41</td>
    <td>40</td>
    <td>40</td>
    <td>41</td>
    <td>40</td>
    <td>40</td>
    <td>40</td>
    <td>40</td>
    <td>40</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>30</td>
    <td>동해중앙 캠퍼스</td>
    <td>19</td>
    <td>20</td>
    <td>11</td>
    <td>10</td>
    <td>10</td>
    <td>9</td>
    <td>13</td>
    <td>15</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>17</td>
    <td>18</td>
    <td>18</td>
    <td>18</td>
    <td>18</td>
    <td>19</td>
    <td>19</td>
    <td>19</td>
    <td>19</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>31</td>
    <td>리드앤톡</td>
    <td>7</td>
    <td>7</td>
    <td>12</td>
    <td>13</td>
    <td>13</td>
    <td>12</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>14</td>
    <td>15</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>15</td>
    <td>15</td>
    <td>15</td>
    <td>16</td>
    <td>16</td>
    <td>11</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>32</td>
    <td>마이패스원장교육용</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>33</td>
    <td>매곡 캠퍼스</td>
    <td>34</td>
    <td>34</td>
    <td>34</td>
    <td>35</td>
    <td>35</td>
    <td>35</td>
    <td>35</td>
    <td>34</td>
    <td>33</td>
    <td>34</td>
    <td>35</td>
    <td>34</td>
    <td>27</td>
    <td>26</td>
    <td>27</td>
    <td>27</td>
    <td>26</td>
    <td>25</td>
    <td>25</td>
    <td>26</td>
    <td>25</td>
    <td>25</td>
    <td>25</td>
    <td>26</td>
    <td>26</td>
    <td>25</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>34</td>
    <td>별내 캠퍼스</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>35</td>
    <td>보라매 캠퍼스</td>
    <td>47</td>
    <td>47</td>
    <td>47</td>
    <td>47</td>
    <td>47</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>36</td>
    <td>부산장전 캠퍼스</td>
    <td>9</td>
    <td>13</td>
    <td>13</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>9</td>
    <td>9</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>37</td>
    <td>북평캠퍼스</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>15</td>
    <td>15</td>
    <td>14</td>
    <td>14</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>38</td>
    <td>속초 캠퍼스</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>46</td>
    <td>45</td>
    <td>45</td>
    <td>45</td>
    <td>46</td>
    <td>46</td>
    <td>47</td>
    <td>46</td>
    <td>45</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>39</td>
    <td>송도 캠퍼스</td>
    <td>35</td>
    <td>36</td>
    <td>37</td>
    <td>34</td>
    <td>35</td>
    <td>60</td>
    <td>58</td>
    <td>57</td>
    <td>52</td>
    <td>53</td>
    <td>51</td>
    <td>49</td>
    <td>49</td>
    <td>47</td>
    <td>46</td>
    <td>47</td>
    <td>47</td>
    <td>48</td>
    <td>48</td>
    <td>48</td>
    <td>47</td>
    <td>46</td>
    <td>46</td>
    <td>45</td>
    <td>42</td>
    <td>42</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>40</td>
    <td>수원권선 캠퍼스</td>
    <td>20</td>
    <td>21</td>
    <td>21</td>
    <td>19</td>
    <td>18</td>
    <td>18</td>
    <td>19</td>
    <td>21</td>
    <td>21</td>
    <td>21</td>
    <td>21</td>
    <td>21</td>
    <td>21</td>
    <td>21</td>
    <td>21</td>
    <td>20</td>
    <td>20</td>
    <td>19</td>
    <td>19</td>
    <td>19</td>
    <td>8</td>
    <td>1</td>
    <td>0</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>41</td>
    <td>스텔라영어학원</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>4</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>0</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>42</td>
    <td>신대 캠퍼스</td>
    <td>121</td>
    <td>126</td>
    <td>126</td>
    <td>122</td>
    <td>124</td>
    <td>128</td>
    <td>128</td>
    <td>132</td>
    <td>132</td>
    <td>132</td>
    <td>133</td>
    <td>133</td>
    <td>133</td>
    <td>133</td>
    <td>134</td>
    <td>133</td>
    <td>131</td>
    <td>127</td>
    <td>127</td>
    <td>127</td>
    <td>126</td>
    <td>125</td>
    <td>122</td>
    <td>122</td>
    <td>122</td>
    <td>122</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>43</td>
    <td>신원 캠퍼스</td>
    <td>12</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>15</td>
    <td>15</td>
    <td>14</td>
    <td>14</td>
    <td>14</td>
    <td>14</td>
    <td>14</td>
    <td>14</td>
    <td>14</td>
    <td>15</td>
    <td>15</td>
    <td>15</td>
    <td>15</td>
    <td>15</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>15</td>
    <td>15</td>
    <td>15</td>
    <td>15</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>44</td>
    <td>신정 캠퍼스</td>
    <td>54</td>
    <td>55</td>
    <td>55</td>
    <td>52</td>
    <td>52</td>
    <td>60</td>
    <td>60</td>
    <td>58</td>
    <td>58</td>
    <td>58</td>
    <td>58</td>
    <td>57</td>
    <td>56</td>
    <td>55</td>
    <td>55</td>
    <td>55</td>
    <td>55</td>
    <td>55</td>
    <td>55</td>
    <td>59</td>
    <td>60</td>
    <td>61</td>
    <td>61</td>
    <td>61</td>
    <td>60</td>
    <td>60</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>45</td>
    <td>아론효천 캠퍼스</td>
    <td>5</td>
    <td>6</td>
    <td>6</td>
    <td>5</td>
    <td>5</td>
    <td>7</td>
    <td>7</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>5</td>
    <td>5</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>5</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>46</td>
    <td>아산탕정 캠퍼스</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>9</td>
    <td>9</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td>6</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>47</td>
    <td>신길뉴타운</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td>75</td>
    <td>79</td>
    <td>70</td>
    <td>65</td>
    <td>64</td>
    <td>61</td>
    <td>61</td>
    <td>60</td>
    <td>60</td>
    <td>57</td>
    <td>55</td>
    <td>55</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>48</td>
    <td>에쥬니티씨엘신길뉴타운어학원</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>55</td>
    <td>55</td>
    <td>51</td>
    <td>47</td>
    <td>47</td>
    <td>47</td>
    <td>47</td>
    <td>47</td>
    <td>46</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>49</td>
    <td>엔씨 아카데미</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>15</td>
    <td>15</td>
    <td>15</td>
    <td>15</td>
    <td>15</td>
    <td>15</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>0</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>50</td>
    <td>여수 캠퍼스</td>
    <td>190</td>
    <td>187</td>
    <td>186</td>
    <td>180</td>
    <td>180</td>
    <td>178</td>
    <td>179</td>
    <td>196</td>
    <td>190</td>
    <td>190</td>
    <td>188</td>
    <td>186</td>
    <td>181</td>
    <td>178</td>
    <td>179</td>
    <td>180</td>
    <td>179</td>
    <td>177</td>
    <td>175</td>
    <td>176</td>
    <td>175</td>
    <td>171</td>
    <td>169</td>
    <td>169</td>
    <td>170</td>
    <td>167</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>51</td>
    <td>오산운암 캠퍼스</td>
    <td>61</td>
    <td>62</td>
    <td>63</td>
    <td>61</td>
    <td>61</td>
    <td>65</td>
    <td>65</td>
    <td>64</td>
    <td>65</td>
    <td>65</td>
    <td>65</td>
    <td>65</td>
    <td>66</td>
    <td>65</td>
    <td>65</td>
    <td>64</td>
    <td>64</td>
    <td>64</td>
    <td>63</td>
    <td>63</td>
    <td>64</td>
    <td>65</td>
    <td>65</td>
    <td>65</td>
    <td>65</td>
    <td>64</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>52</td>
    <td>원주기업도시 캠퍼스</td>
    <td>95</td>
    <td>95</td>
    <td>95</td>
    <td>95</td>
    <td>94</td>
    <td>104</td>
    <td>104</td>
    <td>105</td>
    <td>104</td>
    <td>103</td>
    <td>102</td>
    <td>101</td>
    <td>95</td>
    <td>92</td>
    <td>90</td>
    <td>103</td>
    <td>101</td>
    <td>100</td>
    <td>100</td>
    <td>100</td>
    <td>86</td>
    <td>84</td>
    <td>81</td>
    <td>97</td>
    <td>101</td>
    <td>102</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>53</td>
    <td>월곡인재 캠퍼스</td>
    <td>6</td>
    <td>6</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>6</td>
    <td>6</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>6</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>54</td>
    <td>월드컵 캠퍼스</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>3</td>
    <td>3</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>55</td>
    <td>유천 캠퍼스</td>
    <td>54</td>
    <td>63</td>
    <td>62</td>
    <td>65</td>
    <td>67</td>
    <td>67</td>
    <td>67</td>
    <td>69</td>
    <td>70</td>
    <td>72</td>
    <td>70</td>
    <td>68</td>
    <td>67</td>
    <td>67</td>
    <td>66</td>
    <td>66</td>
    <td>66</td>
    <td>65</td>
    <td>65</td>
    <td>65</td>
    <td>56</td>
    <td>54</td>
    <td>54</td>
    <td>54</td>
    <td>54</td>
    <td>54</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>56</td>
    <td>이수 캠퍼스</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>6</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>57</td>
    <td>인천(브레인플러스)</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>9</td>
    <td>8</td>
    <td>8</td>
    <td>8</td>
    <td>10</td>
    <td>10</td>
    <td>9</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>10</td>
    <td>9</td>
    <td>11</td>
    <td>12</td>
    <td>10</td>
    <td>10</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>58</td>
    <td><span class="new">NEW</span>장산 캠퍼스</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td>21</td>
    <td>27</td>
    <td>28</td>
    <td>29</td>
    <td>27</td>
    <td>27</td>
    <td>26</td>
    <td>26</td>
    <td>26</td>
    <td>26</td>
    <td>26</td>
    <td>24</td>
    <td>25</td>
    <td>25</td>
    <td>25</td>
    <td>25</td>
    <td>21</td>
    <td>21</td>
    <td>22</td>
    <td>17</td>
    <td>16</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>59</td>
    <td><span class="new">NEW</span>차일드유 범어캠퍼스</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>60</td>
    <td>창원감계 캠퍼스</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>11</td>
    <td>11</td>
    <td>11</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>7</td>
    <td>7</td>
    <td>5</td>
    <td>5</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>7</td>
    <td>7</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>61</td>
    <td>천안백석 캠퍼스</td>
    <td>54</td>
    <td>56</td>
    <td>57</td>
    <td>57</td>
    <td>58</td>
    <td>59</td>
    <td>59</td>
    <td>59</td>
    <td>59</td>
    <td>45</td>
    <td>46</td>
    <td>46</td>
    <td>46</td>
    <td>48</td>
    <td>48</td>
    <td>47</td>
    <td>47</td>
    <td>48</td>
    <td>48</td>
    <td>48</td>
    <td>48</td>
    <td>48</td>
    <td>48</td>
    <td>49</td>
    <td>50</td>
    <td>48</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>62</td>
    <td>청주영재 캠퍼스</td>
    <td>21</td>
    <td>21</td>
    <td>20</td>
    <td>20</td>
    <td>19</td>
    <td>16</td>
    <td>11</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>13</td>
    <td>19</td>
    <td>19</td>
    <td>20</td>
    <td>16</td>
    <td>18</td>
    <td>18</td>
    <td>18</td>
    <td>18</td>
    <td>18</td>
    <td>18</td>
    <td>21</td>
    <td>21</td>
    <td>21</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>63</td>
    <td>청파창의융합학원</td>
    <td>1</td>
    <td>1</td>
    <td>3</td>
    <td>4</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>6</td>
    <td>6</td>
    <td>7</td>
    <td>12</td>
    <td>12</td>
    <td>12</td>
    <td>11</td>
    <td>10</td>
    <td>6</td>
    <td>5</td>
    <td>4</td>
    <td>4</td>
    <td>5</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td>7</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>64</td>
    <td>침산 캠퍼스</td>
    <td>32</td>
    <td>35</td>
    <td>37</td>
    <td>34</td>
    <td>34</td>
    <td>44</td>
    <td>44</td>
    <td>43</td>
    <td>42</td>
    <td>42</td>
    <td>43</td>
    <td>45</td>
    <td>45</td>
    <td>45</td>
    <td>46</td>
    <td>44</td>
    <td>44</td>
    <td>44</td>
    <td>44</td>
    <td>44</td>
    <td>42</td>
    <td>42</td>
    <td>44</td>
    <td>43</td>
    <td>43</td>
    <td>42</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>65</td>
    <td>칼비테 영재</td>
    <td></td>
    <td></td>
    <td>4</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>3</td>
    <td>3</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>2</td>
    <td>1</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>1</td>
    <td>0</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>66</td>
    <td><span class="new">NEW</span>키즈엔리딩(경희궁)</td>
    <td>1</td>
    <td>2</td>
    <td>2</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>1</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>0</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>2</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>6</td>
    <td>6</td>
    <td>2</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>67</td>
    <td>터치잉글리시영어학원</td>
    <td>7</td>
    <td>8</td>
    <td>8</td>
    <td>8</td>
    <td>8</td>
    <td>8</td>
    <td>8</td>
    <td>16</td>
    <td>15</td>
    <td>15</td>
    <td>15</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>16</td>
    <td>9</td>
    <td>9</td>
    <td>9</td>
    <td>9</td>
    <td>9</td>
    <td>9</td>
    <td>0</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>68</td>
    <td>테스트 학원</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>69</td>
    <td>펜타힐즈 캠퍼스</td>
    <td>28</td>
    <td>28</td>
    <td>28</td>
    <td>28</td>
    <td>28</td>
    <td>29</td>
    <td>29</td>
    <td>29</td>
    <td>29</td>
    <td>29</td>
    <td>29</td>
    <td>29</td>
    <td>29</td>
    <td>28</td>
    <td>28</td>
    <td>29</td>
    <td>28</td>
    <td>28</td>
    <td>28</td>
    <td>29</td>
    <td>29</td>
    <td>29</td>
    <td>29</td>
    <td>30</td>
    <td>30</td>
    <td>30</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>70</td>
    <td>포천송우 캠퍼스</td>
    <td>66</td>
    <td>67</td>
    <td>68</td>
    <td>68</td>
    <td>68</td>
    <td>70</td>
    <td>71</td>
    <td>71</td>
    <td>71</td>
    <td>72</td>
    <td>71</td>
    <td>71</td>
    <td>74</td>
    <td>74</td>
    <td>74</td>
    <td>73</td>
    <td>73</td>
    <td>73</td>
    <td>72</td>
    <td>76</td>
    <td>75</td>
    <td>76</td>
    <td>77</td>
    <td>74</td>
    <td>72</td>
    <td>72</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>71</td>
    <td>하리숲학교</td>
    <td>78</td>
    <td>81</td>
    <td>82</td>
    <td>76</td>
    <td>76</td>
    <td>81</td>
    <td>81</td>
    <td>78</td>
    <td>88</td>
    <td>88</td>
    <td>88</td>
    <td>88</td>
    <td>88</td>
    <td>88</td>
    <td>87</td>
    <td>83</td>
    <td>75</td>
    <td>77</td>
    <td>76</td>
    <td>77</td>
    <td>74</td>
    <td>74</td>
    <td>74</td>
    <td>75</td>
    <td>74</td>
    <td>73</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>72</td>
    <td>해운대 캠퍼스</td>
    <td>3</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>5</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>4</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td>3</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr>
    <td>합계</td>
    <td></td>
    <td>1964</td>
    <td>2006</td>
    <td>2025</td>
    <td>1962</td>
    <td>1962</td>
    <td>2157</td>
    <td>2125</td>
    <td>2126</td>
    <td>2100</td>
    <td>2088</td>
    <td>2097</td>
    <td>2084</td>
    <td>2061</td>
    <td>2058</td>
    <td>2065</td>
    <td>2076</td>
    <td>2046</td>
    <td>2037</td>
    <td>2018</td>
    <td>2029</td>
    <td>1970</td>
    <td>1927</td>
    <td>1911</td>
    <td>1939</td>
    <td>1920</td>
    <td>1885</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
    </table>

  </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import QueryGrid from "../components/QueryGrid.vue";
export default {
  components: {
    QueryGrid,
  },
  data: () => ({
    boards: {},
    articles: [],
    selBoard: "",
    search: "",
    firstlists: [],
    firstselected: "1",
    subselected: "",
    sublists: [],
    volselected: "",
    vollists: [],
    config: {
      name: "통계관리 아이디 사용현황",
      req_endpoint: "/admin/stat_sales",
      default_limit: 20,
      search_fields: [
        {
          id: "cate_filter_main",
          name: "본부분류",
          type: "custom",
          custom_name: "main",
        },
        {
          id: "cate_filter_sub",
          name: "캠퍼스분류",
          type: "custom",
          custom_name: "sub",
        },
        {
          id: "date_filter",
          name: "날짜검색",
          type: "date",
        },
      ],
      columns: [
        {
          id: "id",
          name: "번호",
          excel_print: (v) => {
            return 1;
          },
        },
        {
          id: "searchvalue",
          name: "검색분류",
          excel_print: (v) => {
            return v.searchvalue;
          },
        },
        {
          id: "countid",
          name: "주문건수",
          excel_print: (v) => {
            return v.subid;
          },
        },
        {
          id: "onpg",
          name: "카드결제(온라인)",
          excel_print: (v) => {
            return v.CARD_ONPG;
          },
        },
        {
          id: "offpg",
          name: "카드결제(오프라인)",
          excel_print: (v) => {
            return v.CARD_OFFPG;
          },
        },
        {
          id: "cash",
          name: "현금",
          excel_print: (v) => {
            return v.CASH;
          },
        },
        {
          id: "sumTotal",
          name: "총합계",
          excel_print: (v) => {
            return v.subprice;
          },
        },
      ],
    },
  }),
  methods: {
    loadBoard() {
      var extras = "?";
      if (this.search) {
        extras += "&search=" + this.search;
      }
      if (this.subselected) {
        extras += "&cate_filter_type=sub&cate_filter_var=" + this.subselected;
      } else if (this.firstselected) {
        extras +=
          "&cate_filter_type=main&cate_filter_var=" + this.firstselected;
      }
      axios.get("/admin/stat_sales" + extras).then((response) => {
        if (response.data.error) {
          alert("메출을 집계 할 수 없습니다.\n" + response.data.error);
        } else {
          this.articles = response.data.result.articles;
        }
      });
    },
    viewSecond() {
      this.$refs.qg.pushSetting("cate_filter_sub", null);
      this.subselected = null;
      axios
        .get("/admin/sub_categories/" + this.firstselected)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.sublists = response.data.result;
          }
        });
    },
  },
  mounted() {
    //this.loadBoard()
    axios.get("/admin/sub_categories").then((response) => {
      if (response.data.error) {
        $.notify(
          {
            // options
            message: "데이터를 조회할 수 없습니다. " + response.data.error,
          },
          {
            // settings
            type: "danger",
            z_index: 9999,
          }
        );
      } else {
        this.firstlists = response.data.result;
        //console.log(this.firstlists);
      }
    });
  },
};
</script>
